<div class="survey-item">
  <h2 class="heading ion-no-margin" [innerHTML]="titleHtml"></h2>
  <div class="actions">
    <ion-button
      fill="outline"
      size="small"
      class="ion-no-margin"
      appHaptics
      (click)="skipClicked.emit()"
    >
      Skip
    </ion-button>
    <ion-button
      fill="outline"
      size="small"
      class="ion-no-margin"
      appHaptics
      (click)="buttonClicked.emit()"
    >
      Respond
      <span *ngIf="points > 0" class="points-badge">+{{ points }}pts</span>
    </ion-button>
  </div>
</div>
